const accountNumber = {
  field: 'accountNumber',
  headerName: 'Account Number',
  type: 'customSelect',
  flex: 1,
};

const description = {
  field: 'description',
  headerName: 'Description',
  type: 'customSelect',
  flex: 1,
};

const vendor = {
  field: 'vendor',
  headerName: 'Vendor',
  type: 'customSelect',
  flex: 1,
};

const VENDOR_PRICE_ACCOUNT = [vendor, description, accountNumber];

export { VENDOR_PRICE_ACCOUNT };
